<template>
  <div class="game">
    <div class="game_top_content">
      <div class="gameback hidden_m">
        <img :src="bannerPics.pc" />
      </div>
      <div class="gameback hidden_pc">
        <img :src="bannerPics.h5" />
      </div>
      <div class="game_top_main_content">

        <!-- 支付id -->
        <div class="title">
          <span>{{ $t('game.useTitle') }}</span>
          <p v-if="loginsty==2 && !editis" class="findid"  @click="qusetionis = true">
            <span class="circle">?</span>{{$t('game.findid')}}
          </p>
        </div>
        <div style="clear: both;"></div>
        <div v-if="editis == false" class="top_login_con" ref="topLoginContainer">
          <div v-if="loginsty==2">
            <div class="print">
              <input :class="{'gray-input':checkis}" ref="userInput" type="text" :placeholder="$t('game.palceholder')" v-model="gameinfo.id" :disabled="checkis" />
              <span @click="checkid('login')" v-show="!checkis">{{ $t('game.checkUserID') }}</span>
              <span v-show="checkis" class="loadbtn"> <img class="btnload" src="static/images/btnload.png" /></span>
            </div>
            <div class="info" v-if="checktext==''">{{ $t('game.checktext') }}</div>
            <div class="info redcolor" v-else>{{checktext}}</div>
            <div class="checkTips">
              <div class="checkbox" @click="togglePrivacyCheckbox">
                <img src="./images/checkbox_bg.png" alt="">
                <img v-if="privacyChecked" src="./images/checkbox_con.png" alt="">
              </div>
              <div class="checkTips_text">
                <p v-html="transformCheckTips($t('game.checkTIps1'))"></p>
                <p class="checkRequied" v-if="showCheckRequied">{{ $t('game.checkTIps2') }}</p>
              </div>
            </div>
          </div>
          <div v-else-if="loginsty==1">
            <div @click="openlogin" class="applogin_loginbtn loginsty1">{{ $t('game.login') }}</div>
          </div>
        </div>
        <div class="userinfo" v-else-if="editis == true">
          <div class="userinfo_left">
            <div class="avatar_wrap">
              <img class="avatarBg" src="./images/head_pic_bg.png" alt="">
              <img class="avatar" :src="gameinfo.icon" />
            </div>
            <!-- 空div，适配阿拉伯语 -->
            <div class="space_div"></div>
            <div class="username" v-if="!(gameinfo.extra_info && gameinfo.extra_info.key && gameinfo.extra_info.value!='')">
              <p>{{ $t('game.username') }} {{gameinfo.name}}</p>
              <p>{{ $t('game.userId') }} {{gameinfo.role_id}}</p>
            </div>
            <div class="username userthree" v-else>
              <p>{{ $t('game.username') }} {{gameinfo.name}}</p>
              <p>{{ $t('game.userId') }} {{gameinfo.role_id}}</p>
              <!-- <p>{{ $t('extra_info.kingdom') }} {{gameinfo.extra_info.value}}</p>
              <p>{{ $t('game.rongluRank') }}
                <img class="rank_icon" v-if="typeof gameinfo.rank === 'string'" :src="gameinfo.rank" alt="">
                <template v-else>
                  {{ gameinfo.rank }}
                </template>
              </p> -->
            </div>
          </div>
          <img class="edit_pic" src="./images/logout_icon.png" @click="logout()" />
        </div>
        <div style="clear: both;"></div>

        <template v-if="showPackageList">
          <!-- 礼包列表 -->
          <div class="title">
            <span class="title_left">{{ $t('game.packageTitle') }}</span>
          </div>
          <div v-if="editis" class="title_desc">{{ $t('game.selectTips') }}</div>
          <div class="sub_title">
            <span>{{ $t('game.productDescription') }}</span>
            <span @click="userTips = true" class="question_icon">?</span>
            <span @click="userTips = true" class="sub_title_tips">{{ $t('game.tips') }}</span>
          </div>
          <div class="payitem gamepayitem">
            <template v-for="(item,index) in list">
              <!-- diy -->
              <div class="listitem diylist" :keys="index"
                v-if="showid(item.id) && item.package_type && item.package_type==2" @click="selpackage(item)">
                <div class="diycontent">
                  <div class="paytag" v-if="disabledval!='' && item.tag!='' && item.tag+''!='undefined'">
                    <img :src="'/static/images/tag/tag'+item.tag+'.png'" />
                    <span class="tagtotal" v-if="checkList.indexOf('total')>-1">
                      {{ item.package.value_comba +' x' }}
                    </span>
                    <span class="tagtotal numtag" v-if="checkList.indexOf('bonus')>-1">
                      {{ '+' + item.package.give_away_number  }}
                    </span>
                    <span class="tagtotal bonusoff" v-if="checkList.indexOf('bonusoff')>-1">
                      <span> {{ item.package.give_away_rate +'%' }}</span>
                      <span class="bonus">{{gameid=='20073'?'More':'BONUS'}}</span>
                    </span>
                    <span class="tagtotal bonusoff " v-if="checkList.indexOf('off')>-1">
                      <span> {{ item.package.discount +'%' }}</span>
                      <span>OFF</span>
                    </span>
                  </div>
                  <p class="diyimg"><img v-if="checkList.indexOf('packpic')>-1" :src="item.package.package_pic" /></p>
                  <div
                    :class="{'diymian':true,'diynomain':checkList.indexOf('item')==-1 || difpackageinfo['vip'+item.id].other_content.length<=0 }"
                    v-if="checkList.indexOf('mainitems')>-1 && difpackageinfo['vip'+item.id] && difpackageinfo['vip'+item.id].main_content"
                    @click="openother(item.package.diy_main_content,difpackageinfo['vip'+item.id].main_content,'main',item.id)">
                    <img v-if="item.package.diy_main_content.length>1" class="diychange" src="static/images/change.png" />
                    <img class="diymain_content" :src="difpackageinfo['vip'+item.id].main_content.pic_url
    " />
                    <p class="diynumber">
                      <span class="diymainorigin"
                        v-if="checkList.indexOf('mainorigin')>-1">{{setcount(difpackageinfo['vip'+item.id].main_content.main_content_original_number)}}</span>
                      <span>{{setcount(difpackageinfo['vip'+item.id].main_content.main_number)}}</span>
                    </p>
                  </div>
                  <div v-if="checkList.indexOf('item')>-1 &&  difpackageinfo['vip'+item.id].other_content.length>0"
                    :class="{'diyother':true,'diyothernomain':checkList.indexOf('mainitems')==-1 || !difpackageinfo['vip'+item.id].main_content}">
                    <p v-for="(l,i) in difpackageinfo['vip'+item.id].other_content"
                      @click="openother(item.package.diy_other_content['分组'+(i+1)],l,'other',item.id,i)"
                      :class="getotherClass(difpackageinfo['vip'+item.id].other_content)" :keys="i">
                      <img class="diychange"
                        v-if="item.package.diy_other_content['分组'+(i+1)].length && item.package.diy_other_content['分组'+(i+1)].length>1"
                        src="static/images/change.png" />
                      <img :src="l.pic_url" />
                      <span>{{ ' X' + setcount(l.count)}}</span>
                    </p>
                  </div>
                </div>
                <div :class="{'diybottom':true,'diybottomcenter':checkList.indexOf('packname')==-1}">
                  <p class="diyname" v-if="checkList.indexOf('packname')>-1">
                    {{item.package.package_en_name}}
                  </p>
                  <p class="payitembtn" v-if="checkList.indexOf('price')>-1">
                    <span class="paybtnpast"
                      v-if="checkList.indexOf('originprice')>-1">{{moneyunit+ priceinit(item.package.external_amount)}}</span>
                    <span
                      :class="{'paybtnnow':true,'diypaybtnnowonly':checkList.indexOf('originprice') <= -1}">{{ moneyunit + item.package.final_amount}}</span>
                  </p>
                </div>

                <img v-if="item.package.limit_pay_count != 0 && (item.package.limit_pay_count+'') != 'null'" class="imgleft"
                  src="static/images/lefticon.png" />
                <div v-if="item.package.limit_pay_count != 0 && (item.package.limit_pay_count+'') != 'null'"
                  class="leftnum">LEFT {{item.package.limit_pay_count}}</div>

                <div class="soldout" @click.stop="soldout"
                  v-if="(item.package.limit_pay_count*1 == 0 && (item.package.limit_pay_count+'') != 'null')">
                  <img src="static/images/out.png" />
                </div>

                <div :class="{selnow: true}" v-show="packageid == item.id">
                  <img src="static/images/choose_p.png" />
                </div>
              </div>

              <!-- normal -->
              <div class="listitem" :keys="index" v-else-if="showid(item.id) " @click="selpackage(item)">
                <div :class="{selnow: true}" v-show="packageid == item.id">
                  <img src="static/images/choose_p.png" />
                </div>
                <div class="soldout" @click.stop="soldout"
                  v-if="(item.package.limit_pay_count*1 == 0 && (item.package.limit_pay_count+'') != 'null')">
                  <img src="static/images/out.png" />
                </div>
                <img v-if="item.package.limit_pay_count != 0 && (item.package.limit_pay_count+'') != 'null'" class="imgleft"
                  src="static/images/lefticon.png" />
                <div v-if="item.package.limit_pay_count != 0 && (item.package.limit_pay_count+'') != 'null'"
                  class="leftnum">LEFT {{item.package.limit_pay_count}}</div>

                <div class="packageimg">
                  <!-- <p class="paytitle" v-if="checkList.indexOf('packname')>-1">{{item.package.package_en_name}}</p> -->
                  <img class="payall" v-if="checkList.indexOf('packpic')>-1" :src="item.package.package_pic" />
                  <!-- <p class="paytag" v-if="disabledval!='' && item.tag!='' && item.tag+''!='undefined'">
                    <img :src="'/static/images/tag/tag'+item.tag+'.png'" />
                    <span class="tagtotal" v-if="checkList.indexOf('total')>-1">
                      {{ item.package.value_comba +' x' }}
                    </span>
                    <span class="tagtotal numtag" v-if="checkList.indexOf('bonus')>-1">
                      {{ '+' + item.package.give_away_number  }}
                    </span>
                    <span class="tagtotal bonusoff" v-if="checkList.indexOf('bonusoff')>-1">
                      <span> {{ item.package.give_away_rate +'%' }}</span>
                      <span class="bonus">{{gameid=='20073'?'More':'BONUS'}}</span>
                    </span>
                    <span class="tagtotal bonusoff " v-if="checkList.indexOf('off')>-1">
                      <span> {{ item.package.discount +'%' }}</span>
                      <span>OFF</span>
                    </span>
                  </p> -->
                  <img class="gof_bouns" v-if="item.tag == 1" :src="pics.bouns" alt="">
                  <div class="itemlist" v-if="checkList.indexOf('item')>-1">
                    <p v-for="(l,i) in item.package.other_content"
                      :class="{'itemlistitem':true,'nowarpitem':item.package.other_content.length==3}" :keys="i">
                      <img :src="l.content" />
                      <span>{{l.count.toLocaleString()}}</span>
                    </p>
                  </div>
                </div>
                <!-- <div class="maincontent" v-if="checkList.indexOf('mainitems')>-1">
                  <p class="original_number" v-if="checkList.indexOf('mainorigin')>-1">
                    <span
                      v-if="item.package.main_content_original_number >0 ">{{setcount(item.package.main_content_original_number)}}</span>
                    <span v-else></span>
                  </p>
                  <p class="itemlistitem">
                    <img :src="item.package.main_content" />
                    <span>{{setcount(item.package.main_number)}}</span>
                  </p>

                </div> -->

                <p class="payitembtn" v-if="checkList.indexOf('price')>-1">
                  <span v-if="checkList.indexOf('originprice')>-1"
                    class="paybtnpast">{{moneyunit+ priceinit(item.package.external_amount)}}</span>
                  <span
                    :class="{'paybtnnow':true,'paybtnnowonly':checkList.indexOf('originprice') <= -1}">{{ moneyunit + item.package.final_amount}}</span>
                </p>
              </div>

            </template>
            <div class="listitem_space"></div>
            <div class="listitem_space"></div>
            <div class="nopackage" v-if="list.length === 0">
              <p v-if="nopackis"> {{ $t('game.packageLoadingText') }}</p>
            </div>
            <div class="nopackage" v-if="shownopackage()">
              <p> {{ $t('game.packageLoadingText') }}</p>
            </div>

          </div>
          <!-- 支付选择 -->
          <div class="title">
            {{ $t('game.paymentTitle') }}
          </div>
          <div class="payimgflex">
            <div
              v-for="(item, index) in payway"
              :key="index"
              :class="{
                'payimg':true,
                'payimgall': payway.length === 1
              }"
              @click="paychange(item)">
              <template v-if="item === 'adyen'">
                <!-- {{ $t('payment.card') }} -->
                Card
                <img class="pay_icon" src="./images/icon_adyen.png" alt="">
              </template>
              <template v-if="item === 'paypal'">
                {{ $t('payment.paypal') }}
                <img class="pay_icon" src="./images/icon_paypal.png" alt="">
              </template>
              <img class="paychose" src="static/images/choose.png" v-if="paysty == item" />
            </div>
          </div>
        </template>
        <img class="apology_pic" v-if="showApologyPic" :src="apology_pic" />
        <Foot :showParagraph="showPackageList"></Foot>
      </div>
    </div>
    <div class="pay payfly" v-if="showPackageList">
      <div class="userid" v-if="gameinfo.role_id!=''">
        {{ $t('game.account') }}:
        <span>
          {{`${gameinfo.name}(ID# ${gameinfo.role_id})`}}
        </span>
        <span class="redcolor" v-if="checktext!=''">{{checktext}}</span>
      </div>
      <div class="bottom_pay_con">
        <div class="money">
          <p>{{ $t('game.total') }}: <span>{{ moneyunit + gameinfo.money}}</span></p>
          <p class="moneyexplain">
            <template v-if="isGlobal">
              <b v-if="pakcageis">{{ $t('game.taxTips') }}</b>
              <b class="redcolor" v-else>{{ $t('game.noSelectPackageTips') }}</b>
            </template>
            <template v-else>
              <b class="redcolor" v-if="!packageid">{{ $t('game.noSelectPackageTips') }}</b>
            </template>
          </p>
        </div>
        <div @click="gotodetail" :class="{
          paybtn: true,
          disabled: (!packageid) || !editis
        }">{{ $t('game.payButton') }}</div>
      </div>
    </div>
    <!-- 支付结果 -->
    <div class="mask" v-if="maskstyle != '' && !invoiceis">
      <div class="mask_main_content">
        <img v-if="maskstyle !== 'success'" class="close" @click="maskstyle = ''" src="static/images/close.png" />
        <div class="alertmain">

          <div class="alerthead">
            <img v-show="maskstyle == 'success'" src="static/images/success.png" />
            <img v-show="maskstyle !== 'success'" src="static/images/fail.png" />
            <p v-if="maskstyle == 'payfail'">
              <span class="alertinfo">
                {{ $t('game.payFail') }}
              </span>
              <span>
                {{ paysty=='paypal'? $t('game.payFailTips2') : $t('game.payFailTips1') }}
              </span>
            </p>
            <p v-else-if="maskstyle == 'deliveryfail'">
              <span class="alertinfo">
                {{ $t('game.deliveryFail') }}
              </span>
              <span>{{ $t('game.deliveryFailTips') }}</span>
            </p>
            <p v-else-if="maskstyle == 'success'">
              <span class="alertinfo">
                {{ $t('game.paySuccess') }}
              </span>
              <span>{{ $t('game.paySuccessTips') }}</span>
            </p>
            <p v-else>
              <span class="alertinfo">
                {{ $t('game.payFail') }}
              </span>
              <!-- <span>Please wait a moment for delivery</span> -->
            </p>
          </div>

          <div class="alertcontent">
            <div v-if="maskstyle == 'success'" class="tip">
              {{ $t('game.paySuccessTips2') }}
            </div>
            <p class="alerttitle">{{ $t('game.orderTitle') }}</p>
            <p>
              <span>{{ $t('game.paidWith') }}</span>
              <span>{{paysty}}</span>
            </p>
            <p v-if="orderinfo.OrderID!=''">
              <span>{{ $t('game.orderID') }}</span>
              <span>{{orderinfo.OrderID}}</span>
            </p>
            <!-- <p v-if="orderinfo.TransactionID!=''">
              <span>{{ $t('game.transactionId') }}</span>
              <span>{{orderinfo.TransactionID}}</span>
            </p> -->
            <p>
              <span>{{ $t('game.payStatus') }}</span>
              <span v-if="maskstyle == 'payfail'" style="color: orangered;">{{ $t('game.camelPayfail') }}</span>
              <span v-else-if="maskstyle == 'deliveryfail'"
                style="color: orangered;">{{ $t('game.camelDeliveryFail') }}</span>
              <span v-else-if="maskstyle == 'success'" style="color: #3BE487;">{{ $t('game.camelPaySuccess') }}</span>
              <span v-else style="color: #orangered;">{{maskstyle}}</span>
            </p>
            <p>
              <span>{{ $t('game.orderTotal') }}</span>
              <span>{{moneyunit + orderinfo.real_amount}}</span>
            </p>
            <p v-if="orderinfo.Transactiondate!=''">
              <span>{{ $t('game.transactionDate') }}</span>
              <span>{{orderinfo.Transactiondate}}</span>
            </p>
          </div>

          <div class="alertbtn">
            <template v-if="maskstyle == 'success' || maskstyle == 'deliveryfail'">
              <p @click="invoiceis = true;" class="actionBtn solid">
                {{ $t('invoice.button1') }}</p>
              <p class="actionBtn hollow" @click="showNoReceiptConfirmModal">{{ $t('invoice.button2') }}</p>
            </template>
            <p v-else @click="maskstyle = ''" class="actionBtn solid">
              {{ $t('game.goOnPay') }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 确认订单 -->
    <div class="mask" v-if="orderconfirm">
      <div class="mask_main_content">
        <img class="close" @click="orderconfirm = false" src="static/images/close.png" />
        <div class="alertmain">
          <div class="alerthead" style="height: 1.875rem;">
            <p><span class="alertinfo">{{ $t('game.confirmOrder') }}</span></p>
          </div>

          <div class="alertcontent">
            <p class="alerttitle">{{ $t('game.confirmFollow') }}</p>
            <p>
              <span>{{ $t('game.nickname') }}</span>
              <span>{{gameinfo.name+"("+gameinfo.id+")"}}</span>
            </p>
            <p>
              <span>{{ $t('game.packageName') }}</span>
              <span>{{gameinfo.packagename}}</span>
            </p>
            <p>
              <span>{{ $t('game.confirmPayWith') }}</span>
              <span>{{paysty}}</span>
            </p>
            <p class="alerttotal">
              <span>{{ $t('game.totalPayment') }}</span>
              <span style="color: #3BE487;font-size: 1.125rem;">{{moneyunit + gameinfo.money}}</span>
            </p>
          </div>
          <div class="explain" v-if="paysty === 'adyen'" v-html="$t('game.adyenTips')"></div>
          <div class="explain" v-if="paysty === 'paypal'" v-html="$t('game.paypalTips')"></div>
          <div class="explain" v-if="paysty === '微信'">
            支付服务由微信支付提供。若您想了解微信支付的信息安全政策，请前往：<a
              href="https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy">https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy</a>
          </div>
          <div class="explain" v-if="paysty === '支付宝'">
            支付服务由支付宝提供。若您想了解支付宝支付的信息安全政策，请前往：<a
              href="https://render.alipay.com/p/yuyan/180020010001196791/preview.html?agreementId=AG00000132">https://render.alipay.com/p/yuyan/180020010001196791/preview.html?agreementId=AG00000132</a>
          </div>
          <div class="alertbtn">
            <p class="big" @click="pay">{{ $t('game.confirmAndGoOn') }}</p>
            <p class="small" @click="orderconfirm = false">{{ $t('game.orderCancel') }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- <div style="display: flex;height: 500px;">
      <div style="flex-grow: 1;"></div>
      <div style="height: 100px;"></div>
    </div> -->
    <!-- 获取凭据 -->
    <div class="mask" v-if="invoiceis">
      <div class="mask_main_content">
        <img class="invoice_back" @click="invoiceis = false" src="./images/back.png" />
        <div class="alertmain">
          <div class="alerthead" style="height: 1.875rem;">
            <p><span class="alertinfo">{{ $t('game.getInvoiceTitle') }}</span></p>
          </div>
          <div class="alertcontent">
            <p class="alerttitle invoicetitle">{{ $t('game.getInvoiceTips') }}</p>
            <div class="email">
              <input type="text" :placeholder="$t('game.getInvoiceTips1')" v-model="mail_data.mail" />
            </div>
            <!-- <div class="checkbox">
              <label for="collection"> <input id="collection" name="collection" type="checkbox"
                  v-model="mail_data.is_remember" />{{ $t('game.getInvoiceTips2') }}</label>

              <label for="send"><input id="send" name="send" type="checkbox"
                  v-model="mail_data.is_send_information" />{{ $t('game.getInvoiceTips3') }}</label>
            </div> -->
          </div>

          <div class="alertbtn">
            <p class="actionBtn solid" @click="sendInvoice">{{ $t('game.invoiceSend') }}</p>
          </div>
        </div>
      </div>
    </div>

    <template v-if="shwoPayComponent">
      <div>
        <Ayden v-if="paysty === 'adyen'" :payinfo="payinfo" :mount="mount" :user_id="gameinfo.id"></Ayden>
        <Paypal
          v-if="paysty === 'paypal'"
          :payinfo="payinfo"
          :mount="mount"
          :paypal_client_id="paypal_client_id"
          :advanceCardSupport="advanceCardSupport"
          :is_paypal_advance="is_paypal_advance"
          :user_id="gameinfo.id"
          />
        <Wechat v-if="paysty === '微信'" :payinfo="payinfo"></Wechat>
        <Alipay v-if="paysty === '支付宝'" :payinfo="payinfo"></Alipay>
      </div>
    </template>
    <Other v-if="otherselectis" :otherlist="otherlist" :nowselect="nowselect"></Other>
    <div class="mask apploginmask" v-if="apploginis">
        <div class="applogin" v-show="apploginsty == 1">
          <img @click="closeAppLoginModal" class="closegrey" src="static/images/closegrey.png" />
          <img class="applogin_logo" src="static/images/logo.png" />
          <div class="applogin_loginbtn applogin_loginbtn_fist" @click="jumpGame">
            <img src="static/images/gameicon.png" /> {{ $t('game.loginbtn') }}
          </div>
          <p class="applogin_text" @click="apploginsty=2">{{ $t('game.changebtn')}}</p>
        </div>

        <div class="applogin" v-show="apploginsty == 2">
          <img @click="closeAppLoginModal" class="closegrey" src="static/images/closegrey.png" />
          <img class="applogin_logo" src="static/images/logo.png" />

          <div class="title">
            <span class="test">{{ $t('game.loginuserid') }}</span><span class="circle" @click="qusetionis = true">?</span>
          </div>
          <div class="applogin_input">
            <!-- v-model="gameinfo.id" -->
            <input type="text" :class="{'gray-input':checkis}" v-model="gameinfo.id"  :disabled="checkis" :placeholder="$t('game.palceholder')" />
          </div>
          <div class="info redcolor">{{checktext}}</div>
          <div class="applogin_loginbtn applogin_input_btn" v-show="!checkis" @click="checkid('login')">
          {{ $t('game.okbtn') }}
          </div>
          <div class="applogin_loginbtn applogin_input_btn loadbtn" v-show="checkis" >
              <img class="btnload" src="static/images/btnload.png" /> {{ $t('game.okbtn') }}
          </div>
          <div class="circlebtn" v-if="!appenv" @click="jumpGame">
            <img src="static/images/gameicon.png" />
          </div>
          <p class="applogin_text" v-else @click="jumpGame">{{ $t('game.inapptext')}}</p>
        </div>

    </div>

    <!-- userid引导框 -->
    <div class="mask qusetionis" v-show="qusetionis" @click.stop="qusetionis = false">
      <img class="close" @click="qusetionis = false" src="static/images/close.png" />
      <div class="qusetion">
        <div v-for="(item,index) in  quesarrr" :keys="index">
          <!-- <p>{{index*1+1+' '}}.</p> -->
          <img :src="item" />
        </div>
      </div>
    </div>

    <div class="mask qusetionis" v-show="userTips" @click.stop="userTips = false">
      <img class="close" @click="userTips = false" src="static/images/close.png" />
      <div class="qusetion">
        <img :src="pics.userTips" />
      </div>
    </div>

    <Notice ref="notice" :content="noticeinfo.content" :canceltext="noticeinfo.canceltext" :oktext="noticeinfo.oktext" :success="noticeinfo.success" :cancel="noticeinfo.cancel" :title="noticeinfo.title"></Notice>

  </div>
</template>

<script>
  import './game.css';
  import {
    gamePackagesInfo,
    gameInfo,
    checkfpid,
    getinvoice,
    adyen_payments_details,
    packagesinfo,
    upcustomurl,
    getSession,
    getUserInfoBySession
  } from '@/api/index.js'
  import PaymentLog from "../tool/payment.js"
  import Foot from '@/components/common/foot.vue'
  import Ayden from '@/components/common/ayden.vue'
  import Paypal from '@/components/common/paypal.vue'
  import Wechat from '@/components/common/wechat.vue'
  import Alipay from '@/components/common/alipay.vue'
  import Other from '@/components/common/otherselect.vue'
  import Notice from '@/components/common/notice.vue'
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  import conutryarr from '@/components/common/country.js'

  const banner_en_pc = require('../components/images/banners/pc/EN.png')
  const banner_en_m = require('../components/images/banners/h5/EN.png')

  // const banner_ar_pc = require('../components/images/banner_ar/banner_gof.png')
  // const banner_ar_m = require('../components/images/banner_ar/banner_gof_m.png')

  const banner_hans_pc = require('../components/images/banners/pc/zh-Hans.png')
  const banner_hans_m = require('../components/images/banners/h5/zh-Hans.png')

  const banner_ja_pc = require('../components/images/banners/pc/JA.png')
  const banner_ja_m = require('../components/images/banners/h5/JA.png')

  const banner_ko_pc = require('../components/images/banners/pc/KO.png')
  const banner_ko_m = require('../components/images/banners/h5/KO.png')

  // const userTips_AR = require('./images/userTips/DE.png')
  const userTips_DE = require('./images/userTips/DE.png')
  const userTips_EN = require('./images/userTips/EN.png')
  const userTips_ES = require('./images/userTips/ES.png')
  const userTips_FR = require('./images/userTips/FR.png')
  const userTips_ID = require('./images/userTips/ID.png')
  const userTips_IT = require('./images/userTips/IT.png')
  const userTips_JA = require('./images/userTips/JA.png')
  const userTips_KO = require('./images/userTips/KO.png')
  const userTips_PL = require('./images/userTips/PL.png')
  const userTips_PT = require('./images/userTips/PT.png')
  const userTips_RU = require('./images/userTips/RU.png')
  const userTips_TH = require('./images/userTips/TH.png')
  const userTips_TR = require('./images/userTips/TR.png')
  // const userTips_VI = require('./images/userTips/TR.png')
  const userTips_NL = require('./images/userTips/NL.png')
  const userTips_zh_Hans = require('./images/userTips/zh-Hans.png')
  const userTips_zh_Hant  = require('./images/userTips/zh-Hant.png')

  // const bouns_AR = require('./images/bouns/DE.png')
  const bouns_DE = require('./images/bouns/DE.png')
  const bouns_EN = require('./images/bouns/EN.png')
  const bouns_ES = require('./images/bouns/ES.png')
  const bouns_FR = require('./images/bouns/FR.png')
  const bouns_ID = require('./images/bouns/ID.png')
  const bouns_IT = require('./images/bouns/IT.png')
  const bouns_JA = require('./images/bouns/JA.png')
  const bouns_KO = require('./images/bouns/KO.png')
  const bouns_PL = require('./images/bouns/PL.png')
  const bouns_PT = require('./images/bouns/PT.png')
  const bouns_RU = require('./images/bouns/RU.png')
  const bouns_TH = require('./images/bouns/TH.png')
  const bouns_TR = require('./images/bouns/TR.png')
  // const bouns_VI = require('./images/bouns/TR.png')
  const bouns_NL = require('./images/bouns/NL.png')
  const bouns_zh_Hans = require('./images/bouns/zh-Hans.png')
  const bouns_zh_Hant = require('./images/bouns/zh-Hant.png')

  export default {
    name: 'game',
    components: {
      Foot,
      Ayden,
      Paypal,
      Wechat,
      Alipay,
      Other,
      Notice
    },
    computed: {
      ...mapGetters([
        'conutry',
        'isGlobal',
        'accept'
      ]),
      // 展示礼包列表条件，游戏未开启白名单设置，或者开启白名单设置且当前用户在游戏白名单内
      showPackageList() {
        console.log(this.game_whitelist_status, this.player_whitelist_status, this.gameinfo.role_id, '====');
        return this.game_whitelist_status === 0 || (this.game_whitelist_status === 1 && this.player_whitelist_status &&
          this.gameinfo.role_id)
      },
      // 是否展示致歉图, 游戏开启白名单设置且当前用户不在游戏白名单内
      showApologyPic() {
        return this.game_whitelist_status === 1 && (!this.player_whitelist_status) && this.gameinfo.role_id
      },
      bannerPics() {
        return {
          EN: {
            pc: banner_en_pc,
            h5: banner_en_m,
          },
          // AR: {
          //   pc: banner_ar_pc,
          //   h5: banner_ar_m,
          // },
          // AR: {
          //   pc: banner_ar_pc,
          //   h5: banner_ar_m,
          // },
          'zh-Hant': {
            pc: banner_hans_pc,
            h5: banner_hans_m,
          },
          JA: {
            pc: banner_ja_pc,
            h5: banner_ja_m,
          },
          KO: {
            pc: banner_ko_pc,
            h5: banner_ko_m,
          },
        }[this.$i18n.locale] || {
          pc: banner_en_pc,
          h5: banner_en_m,
        }
      },
      pics() {
        return {
          // AR: {
          //   userTips: userTips_AR,
          //   bouns: bouns_AR,
          // },
          DE: {
            userTips: userTips_DE,
            bouns: bouns_DE,
          },
          ES: {
            userTips: userTips_ES,
            bouns: bouns_ES,
          },
          FR: {
            userTips: userTips_FR,
            bouns: bouns_FR,
          },
          ID: {
            userTips: userTips_ID,
            bouns: bouns_ID,
          },
          IT: {
            userTips: userTips_IT,
            bouns: bouns_IT,
          },
          JA: {
            userTips: userTips_JA,
            bouns: bouns_JA,
          },
          KO: {
            userTips: userTips_KO,
            bouns: bouns_KO,
          },
          PL: {
            userTips: userTips_PL,
            bouns: bouns_PL,
          },
          PT: {
            userTips: userTips_PT,
            bouns: bouns_PT,
          },
          RU: {
            userTips: userTips_RU,
            bouns: bouns_RU,
          },
          TH: {
            userTips: userTips_TH,
            bouns: bouns_TH,
          },
          TR: {
            userTips: userTips_TR,
            bouns: bouns_TR,
          },
          // VI: {
          //   userTips: userTips_VI,
          //   bouns: bouns_VI,
          // },
          NL: {
            userTips: userTips_NL,
            bouns: bouns_NL,
          },
          EN: {
            userTips: userTips_EN,
            bouns: bouns_EN,
          },
          'zh-Hans': {
            userTips: userTips_zh_Hans,
            bouns: bouns_zh_Hans,
          },
          'zh-Hant': {
            userTips: userTips_zh_Hant,
            bouns: bouns_zh_Hant,
          },
        }[this.$i18n.locale] || {
          userTips: userTips_EN,
          bouns: bouns_EN,
        }
      }
    },
    watch: {
      invoiceis(newVal) {
        this.mail_data = {
          mail: "",
          is_remember: false,
          is_send_information: false
        }
      }
    },
    data() {
      return {
        gameinfo: {
          id: '',
          icon: '',
          role_id: '',
          money: 0,
          name: '',
          packagename: '',
          extra_info: {}
        },
        privacyChecked: false,
        showCheckRequied: false,
        // 礼包使用引导图
        userTips: false,
        // 游戏头图
        gameBanner: null,
        // 游戏是否开启白名单
        game_whitelist_status: 1,
        // 用户是否在游戏白名单内
        player_whitelist_status: false,
        // 开启白名单时，礼包列表为空，展示致歉图
        apology_pic: null,
        fpid: '',
        checktext: '',
        //钱符号
        moneyunit: '',
        gameid: '',
        editis: false,
        checkList: [],
        list: [],
        nopackis: false,
        listid: '',
        disabledval: "",
        packageid: '',
        //分享人
        owner: '',
        //礼包字典
        packagedict: {

        },
        //控制弹框 payfail 支付失败, deliveryfail 充值失败,success 成功
        maskstyle: '',
        orderinfo: {
          OrderID: '',
          TransactionID: '',
          Transactiondate: '',
          real_amount: ''
        },
        // 确认订单弹窗
        orderconfirm: false,
        // 获取凭证弹窗
        invoiceis: false,
        //提示图片组
        qusetionis: false,
        quesarrr: [],
        //控制支付
        payinfo: {},
        mount: {},
        mail_data: {
          mail: "",
          is_remember: false,
          is_send_information: false
        },
        shortitem: false,
        //防止误触
        clickis: true,
        provider_order_id: '',
        redirectResult: '',
        pakcageis: true,
        // 当前支持的支付方式列表
        payway: [],
        // 当前选择支付方式
        paysty: null,
        // 是否显示对应的支付组件
        shwoPayComponent: false,
        // paypal高级卡支付是否支持当前币种，false为不支持当前币种或者游戏未开启高级卡支付
        advanceCardSupport: false,
        // 是否是新版paypal支付
        is_paypal_advance: false,
        paypal_client_id:'',
        //
        env: process.env.NODE_ENV,
        payment_log: null,
        payment_appid: '',
        gatewayMap: {
          '微信': 43,
          '支付宝': 14,
          paypal: 0,
          adyen: 75
        },
        gateway_package_ids: {},
        // adyen价格精度 文档地址： https://docs.adyen.com/development-resources/currency-codes/
        adyenDecimalPrecision: 2,
        //用于追踪是否打开链接
        code: '',
        watchis: false,
        //游戏选择控制
        otherselectis: false,
        nowselect: {},
        otherselectsty: '',
        otherlist: [],
        //diy礼包配置
        difpackageinfo: {},
        //login方式
        apploginsty:1,
        apploginis:false,
        //login样式种类
        loginsty:3,
        noticeinfo:{
          content:'',
          success:null,
          cancel:0
        },
        //限制check 连点
        checkis:false,
        // 游戏登陆信息
        game_login_info: {},
        appenv:false,
        sessionclickis:false,
        getInvoicing: false, // 是否正在生成支付凭证
      }
    },
    created() {
      this.setShowLoading(true)
      // this.gameid = 20121;
      this.gameid = 20048;
      if (this.getQueryString('list_id')) {
        this.list_id = this.getQueryString('list_id');
      }

      //判断是否在ajust 跳转异常的app中打开
      this.appenvtest();


      //获取用户的登录信息
      if (this.getQueryString('uid')) {
        //先取url的id
        this.gameinfo.id = this.getQueryString('uid');
      }else if(this.gameid){
        //没有的话查看本地是否有uid
        var uid =  localStorage.getItem("game_user_id_"+this.gameid);
        if(uid && uid!=''){
          this.gameinfo.id = uid;
        } else {
          this.$ta.track('tpp_vip_mall_view')
        }
      }

      if (this.getQueryString('pack')) {
        this.packageid = this.getQueryString('pack');
      }
      if (this.getQueryString('owner')) {
        this.owner = this.getQueryString('owner');
      }

      if (this.getQueryString('provider_order_id')) {
        this.provider_order_id = this.getQueryString('provider_order_id');
      }


      if (this.getQueryString('gateway')) {
        const payWayMap = {
          43: '微信',
          14: '支付宝',
          0: 'paypal',
          75: 'adyen',
        }
        this.paysty = payWayMap[this.getQueryString('gateway')];
      }

      if (this.getQueryString('code')) {
        this.code = this.getQueryString('code');
      }

      //支付上报初始化
      this.payment_log = new PaymentLog();
      this.payment_log.init({
        env: this.env,
        app_id: this.env == 'production' ? 'web_vip_mall.global.prod' : 'web_vip_mall.global.sandbox',
        fornt_name: 'web-vip-mall'
      })

      this.getGameInfo();

      this.$rum.setShareProperties({
        gameid: this.gameid
      })

      this.$ta.setSuperProperties({
        country: this.conutry.content,
      })


    },
    beforeDestroy() {
      //先删防止重复监听
      document.removeEventListener("visibilitychange", this.visibilitychangefn);
    },
    methods: {
      ...mapActions([
        'setShowLoading'
      ]),
      // 二次确认弹窗
      showNoReceiptConfirmModal() {
        this.opennotice(this.$t('invoice.giveupInvoice'),()=>{},()=>{
          this.maskstyle = ''
        },this.$t('game.orderCancel'),this.$t('game.confirm'))
      },
      togglePrivacyCheckbox() {
        this.privacyChecked = !this.privacyChecked
        if (this.privacyChecked) {
          this.showCheckRequied = false
        }
      },
      transformCheckTips(text) {
        const localeMap = {
          "EN": '',
          "zh-Hans": 'zh/',
          "zh-Hant": 'zh/',
          KO: 'ko/',
          JA: 'ja/',
        }
        const policyUrl = `https://www.centurygames.com/${localeMap[this.$i18n.locale] || ''}privacy-policy`
        const serviceURl =  `https://www.centurygames.com/${localeMap[this.$i18n.locale] || ''}terms-of-service/`
        const paymentLocaleMap = {
          EN: 'EN',
          'zh-Hans': 'zh-Hans',
        }
        const paymentUrl = `./static/terms/${paymentLocaleMap[this.$i18n.locale] || 'EN'}.html`
        return text.replace(`:href="policyUrl"`, `target="_blank" href="${policyUrl}"`)
                .replace(`:href="serviceURl"`, `target="_blank" href="${serviceURl}"`)
                  .replace(`:href="paymentURl"`, `target="_blank" href="${paymentUrl}"`)
      },
      closeAppLoginModal() {
        this.apploginis=false;
        this.apploginsty = 1;
      },
      openlogin(){
        if(this.appenv == true){
          this.apploginsty = 2;
        }
        this.apploginis=true;
      },
      appenvtest(){
        //在facebook或isMessenger打开
        const isMessenger = /FBAV\//i.test(navigator.userAgent);
        //dingding
         const isdingding = /DingTalk/i.test(navigator.userAgent);
        //Snapchat、Instagram、line、
        const isSnapchat = /Snapchat/i.test(navigator.userAgent);
        const isInstagram = /Instagram/i.test(navigator.userAgent);
        const isLINE = /Line/i.test(navigator.userAgent);

        if (isMessenger || isdingding || isSnapchat || isInstagram || isLINE) {
          this.appenv = true;
        } else {
        	this.appenv = false;
        }
      },
      jumpGame() {
        if(this.appenv == true){
          this.opennotice(this.$t('game.appnotice'),'notice')
        }else{

          //弹一个弹框用来防止监听失效或者不支持监听的浏览器
          setTimeout(()=>{
            this.opennotice(this.$t('game.reloadmsg'), this.checksession,'',this.$t('game.reload'));
          },2000)

          //说明点击跳转了
          this.sessionclickis = true;

          if (window.self !== window.top) {
              console.log("页面是在 iframe 中打开的");
              window.open(this.game_login_info.login_url);
          } else {
              console.log("页面不是在 iframe 中打开的");
              window.location.href = this.game_login_info.login_url;
          }

        }
      },
      //获取session和url
      async getsession(){
        const sessionKey = this.gameid + 'vip_mall_code'
        var vip_mall_code = localStorage.getItem(sessionKey);
        var vip_mall_url = localStorage.getItem(sessionKey + "_url");
        if(vip_mall_code && vip_mall_code!=''){
          //说明有session 同时还没有登录，使用缓存当中的
          this.game_login_info = {
            session :vip_mall_code,
            login_url :vip_mall_url
          }

          //尝试去更新session
          this.checksession('nomsg');
        }else{
           //说明没有session 去请求
           try {
             const res = await getSession({
               game_id: this.gameid
             })
             if (res.data.code === 1) {
               this.game_login_info = res.data.data
               window.localStorage.setItem(sessionKey,this.game_login_info.session);
               window.localStorage.setItem(sessionKey+"_url", this.game_login_info.login_url);
             }
           } catch (error) {
             console.log(error);
           }
        }

        //先删防止重复监听
        document.removeEventListener("visibilitychange", this.visibilitychangefn);
        // 检测页面可见性的改变
        document.addEventListener("visibilitychange",this.visibilitychangefn);

      },
      visibilitychangefn(){
        if (document.hidden) {
          // 页面被隐藏时的操作
          console.log("页面被隐藏");
        } else {
          // alert('show')
          console.log("页面显示了");

          //关闭掉确认弹框
          if(this.$refs.notice){
            this.$refs.notice.close();
          }


          //校验登录情况
          this.checksession()
        }
      },
      //获取登录信息
      async checksession(nomsg){

        //成功checksession后，请除session的local缓存
        //console.log("id");
        this.checkid('leftcount', null, this.game_login_info.session,nomsg);
        //console.log(this.game_login_info.session);

      },
      logout(){
        this.opennotice(this.$t('game.changeaccount'),()=>{},()=>{
          this.editis = false;
          this.$ta.track('tpp_vip_mall_combine', {
            type: 2,
          })
          this.$ta.unsetSuperProperty("fake_id");
          this.$ta.unsetSuperProperty("fpid");
          this.$ta.unsetSuperProperty("uid");
          this.$ta.logout()

          localStorage.removeItem("game_user_id_"+this.gameid);

          //清空信息
          this.$set(this.gameinfo, 'id', '');
          this.$set(this.gameinfo, 'icon', '');
          this.$set(this.gameinfo, 'name', '');
          this.$set(this.gameinfo, 'role_id', '');
          this.$set(this.gameinfo, 'extra_info', {});
          this.$set(this.gameinfo, 'player_whitelist_status', false);
          this.player_whitelist_status = false;

          //如果是移动端同时后台开启了app登录即app_login_status为1时
          if(this.loginsty == 1){
             this.getsession();
          }

          //退出更新一下列表
          this.getPackageInfo();
        },this.$t('game.orderCancel'),this.$t('game.confirm'))
      },
      opennotice(msg,fn,cancel,oktext,canceltext,title){
        this.noticeinfo = {
          content:msg,
          success:fn,
          cancel:cancel,
          oktext:oktext,
          canceltext:canceltext,
          title:title
        }
        this.$refs.notice.open();
      },
      getotherClass(item) {
        var cls = 'diyothercontent ' + ('diyother' + item.length);
        return cls;
      },
      paychange(item) {
        this.paysty = item;
        //判断当前商品是否在当前支付方式中
        if (this.gateway_package_ids[this.gatewayMap[this.paysty]]) {
          this.idarr = this.gateway_package_ids[this.gatewayMap[this.paysty]];
          if (!this.idarr.includes(this.packageid)) {
            this.clearid();
          }
        }
      },
      shownopackage() {
        var showis = false;
        // console.log('this.gateway_package_ids[this.gatewayMap[this.paysty]]')
        // console.log(this.gateway_package_ids[this.gatewayMap[this.paysty]])
        if (this.list.length !== 0 && (!(this.gateway_package_ids && this.gateway_package_ids[this.gatewayMap[this.paysty]]) || this
            .gateway_package_ids[this.gatewayMap[this.paysty]].length == 0)) {
          showis = true;
        }
        return showis;
      },
      showid(id) {
        // console.log('this.paysty');
        // console.log(this.gateway_package_ids);
        if (this.gateway_package_ids && this.gateway_package_ids[this.gatewayMap[this.paysty]]) {
          this.idarr = this.gateway_package_ids[this.gatewayMap[this.paysty]];
          //console.log(this.idarr)
          return this.idarr.includes(id);
        } else {
          return false
        }
      },
      adyencheckagain() {

        if (this.getQueryString('redirectResult')) {
          this.redirectResult = this.getQueryString('redirectResult');
          this.paychange('adyen')
          var obj = {}
          obj.details = {
            "redirectResult": decodeURI(this.redirectResult)
          }

          this.payment_log.set_properties({
            cg_request_id: this.provider_order_id,
            user: this.gameinfo.id,
            gateway: this.paysty,
            appid: this.payment_appid + ''
          });
          this.payment_log.report('web_payment_check_success');
          this.payment_log.report('web_payment_checkAgain_start');

          this.detailresult({
            "provider_order_id": this.provider_order_id,
            "details": JSON.stringify(obj),
          })
        }
      },
      // 获取游戏信息
      async getGameInfo() {
        try {
          const res = await gameInfo({
            game_id: this.gameid
          })
          const info = res.data.data;
          this.quesarrr = info.guide_pic_list;
          this.game_whitelist_status = info.game_whitelist_status;
          this.apology_pic = info.apology_pic;;
          this.gameBanner = info.icon;
          this.payment_appid = info.appid ? info.appid : '';
          this.is_paypal_advance = info.is_paypal_advance
          //判断登录流程
          if(this.detectDeviceType() == 'Mobile'){

            //如果是移动端同时后台开启了app登录即app_login_status为1时
            if(info.app_login_status == 1){
              this.loginsty = 1;
            }else{
              this.loginsty = 2;
            }

          }else{
            this.loginsty = 2;
          }
          //尝试登录
          if (this.gameinfo.id != '') {
            this.checkid('cacheLogin');
          }else{
            this.getPackageInfo()
            //说明没有登录id，获取session和跳转url
            console.log(this.loginsty+'---------')
            if(this.loginsty == 1){
              //说明开启了登录
              this.getsession()
            }
          }

        } catch (error) {
          console.log(error);
        }
        this.adyencheckagain();
      },
      detectDeviceType() {
        var dt =  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent) ? 'Mobile' : 'PC';


        //判断pad
        if(window.innerWidth < 1024 ){
          dt = 'Mobile';
        }

        return dt;
      },
      soldout() {
        return false;
      },
      setcount(count) {
        if (count > 1000000000000000000) {
          count = outzero((count / 1000000000000000000).toPrecision(3)) + 'bb'
        } else if (count > 1000000000000000) {
          count = outzero((count / 1000000000000000).toPrecision(3)) + 'aa'
        } else if (count > 1000000000000) {
          count = outzero((count / 1000000000000).toPrecision(3)) + 't'
        } else if (count > 1000000000) {
          count = outzero((count / 1000000000).toPrecision(3)) + 'b'
        } else if (count > 1000000) {
          count = outzero((count / 1000000).toPrecision(3)) + 'm'
        } else if (count > 10000) {
          count = outzero((count / 1000).toPrecision(3)) + 'k'
        }

        function outzero(val) {

          var arr = val.toString().split('');
          var l = arr.length;
          if (arr[l - 1] == 0) {
            arr = arr.slice(0, l - 1)
          }
          if (arr[arr.length - 1] == '.') {
            arr = arr.slice(0, arr.length - 1)
          }
          return arr.join('')
        }
        return count;
      },
      updateProviderOrderId(id) {
        this.provider_order_id = id
      },
      sendInvoice() {
        //console.log('send')
        if (this.provider_order_id == '') {
          this.provider_order_id = sessionStorage.getItem('provider_order_id')
        }
        if (this.getInvoicing) return

        this.getInvoicing = true

        var obj = {

          "game_id": this.gameid,
          "fpid": this.fpid,
          "email": this.mail_data.mail,
          "is_remember": this.mail_data.is_remember + '',
          "is_send_information": this.mail_data.is_send_information + "",
          "provider_order_id": this.provider_order_id,
          language_code: this.$i18n.locale
          // "uuid": this.orderinfo.OrderID,
          // "transaction_id": this.orderinfo.TransactionID,
          // "transaction_date": this.orderinfo.Transactiondate ,
          // "price": this.moneyunit + this.packagedict['package'+this.packageid].package.final_amount,
          // "package_id": this.packageid
        }

        //console.log(obj)
        getinvoice(obj).then(res => {
          if (res.data.code == 1) {
            this.invoiceis = false;
            if (this.mail_data.is_remember == false) {
              this.$set(this.mail_data, 'mail', '');
            }
            this.alert(this.$t('game.sendSuccess'))
          } else {
            this.alert(res.data.msg)
          }
          this.getInvoicing = false
          this.maskstyle = ''
        }).catch(err => {
          this.alert('request error')
          this.getInvoicing = false
        })


      },
      alert(msg) {
        this.$store.commit('SET_ALERT', {
          type: 'error',
          content: msg,
          showis: true
        })
      },
      //去确认订单
      gotodetail() {
        if (!this.packageid) return
        if (!this.editis) return

        const curPackage = this.packagedict['package' + this.packageid].package

        if (this.packageid == '') {
          return this.pakcageis = false;
        } else {
          this.pakcageis = true;
        }
        this.setShowLoading(true)
        if (this.editis == false) {
          var checkis = true;
          this.checkid('leftcount',() => {
            this.setShowLoading(false)
            if (this.editis == false) {
              //this.alert('ID not found. Please try again.');
              checkis = false;
              window.scrollTo(0, 0)
              if (this.$refs.userInput) {
                this.$refs.userInput.focus()
              }
            }
            if (checkis) {
              if (this.editis == true && this.packageid != '') {
                this.$ta.track('tpp_call_payment', {
                  iap_product_id: curPackage.package_id,
                  payment_type: this.paysty,
                  type: 1,
                  amount: curPackage.final_amount,
                  currency: this.conutry.money,
                })
                this.pay()
              }
            }
          })
        } else {
          if (this.editis == true && this.packageid != '') {
            this.packagereset(() => {
              this.setShowLoading(false)
              if (this.packageid != '') {
                this.$ta.track('tpp_call_payment', {
                  iap_product_id: curPackage.package_id,
                  payment_type: this.paysty,
                  type: 1,
                  amount: curPackage.final_amount,
                  currency: this.conutry.money,
                  // server_id: this.gameinfo.extra_info.value
                })
                this.pay()
              }
            })
          }
        }

      },
      //支付
      pay() {
        if (this.editis == true && this.packageid != '') {
          var obj = {
            game_id: this.gameid,
            uid: this.fpid,
            product_id: this.packagedict['package' + this.packageid].package.package_id,
            pack: this.packageid,
            list_id: this.list_id,
            owner: this.owner,
            amount: this.packagedict['package' + this.packageid].package.final_amount,
            currency: this.conutry.money,
            currency_label: this.moneyunit,
            // gateway和os, 国内支付宝和微信预订单接口特有参数
            gateway: this.gatewayMap[this.paysty],
            os: window.navigator.userAgent.toLocaleLowerCase().indexOf('android') > -1 ? 'android' : 'iOS',
            package_type: this.packagedict['package' + this.packageid].package_type ? this.packagedict['package' +
              this.packageid].package_type : 1,
              //新增id
            role_id:this.gameinfo.role_id,
            // real_role_id: this.gameinfo.real_role_id
          }
          if (this.gameinfo.extra_info && this.gameinfo.extra_info.key) {
            obj.user_extra_key = this.gameinfo.extra_info.key;
            obj.user_extra_value = this.gameinfo.extra_info.value;
          }
          if (obj.package_type == 2) {
            obj.package_info = this.difpackageinfo['vip' + this.packagedict['package' + this.packageid].id];
          } else {
            obj.package_info = {};
          }
          obj.package_info = JSON.stringify(obj.package_info);

          var mountobj = {}
          mountobj.value = Math.round(this.packagedict['package' + this.packageid].package.final_amount * Math.pow(10, this.adyenDecimalPrecision));
          mountobj.currency = this.conutry.money;
          this.$set(this, 'mount', mountobj);

          //清空订单号
          this.$set(this, 'orderinfo', {
            OrderID: '',
            TransactionID: '',
            Transactiondate: '',
            real_amount: ''
          });

          //
          this.payment_log.clear_properties()
          this.payment_log.set_properties({
            user: this.fpid,
            currency_code: this.conutry.money,
            amount: obj.amount,
            product_id: obj.product_id,
            gateway: this.paysty,
            appid: this.payment_appid + ''
          })
          this.payment_log.set_clickid();

          obj.click_id = this.payment_log.logdata.click_id;
          this.$set(this, 'payinfo', obj);

          //paystart
          this.orderconfirm = false;
          console.log('----ajax-')
          console.log(this.difpackageinfo['vip' + this.packagedict['package' + this.packageid].id])
          this.shwoPayComponent = true;

          this.payment_log.report('web_payment_buy_start');
        }
      },
      //检测detail
      detailresult(obj) {
        // var obj = {
        //     // "game_id": this.payinfo.game_id,
        //     "details": JSON.stringify(state.data),
        //     "provider_order_id": this.provider_order_id,
        // }
        adyen_payments_details(obj).then(response => {
          if (response.data.code == 1) {
            this.successpay(response.data.data);
            this.payment_log.set_properties({
              transaction_id: response.data.data.transaction_id ? response.data.data.transaction_id : ''
            });
            this.payment_log.report('web_payment_checkAgain_success');
          } else {
            this.failpay(response.data);
            this.payment_log.report('web_payment_checkAgain_fail', {
              code: 3,
              msg: response.data.msg ? response.data.msg : 'adyen_payments_details failed'
            });
          }
        }).catch(error => {
          this.failpay(error);
          this.payment_log.report('web_payment_checkAgain_error', {
            code: 2,
            msg: error
          });
          throw Error(error);
        });
      },
      //子组件支付成功
      successpay(data) {
        //console.log(data);
        if (data.transaction_id) {
          this.orderinfo.TransactionID = data.transaction_id;
        }
        if (data.uuid) {
          this.orderinfo.OrderID = data.uuid;
        }
        if (data.date) {
          this.orderinfo.Transactiondate = data.date;
        }

        if (data.real_amount) {
          this.orderinfo.real_amount = data.real_amount;
        } else {
          this.orderinfo.real_amount = this.gameinfo.money;
        }

        this.shwoPayComponent = false
        this.maskstyle = 'success';
        this.$rum.report('pay_vip_sucess', data, 1)
        //更新礼包
        this.packagereset();
      },
      //支付失败
      failpay(data) {
        this.shwoPayComponent = false;
        if (data.data) {
          if (data.data.transaction_id) {
            this.orderinfo.TransactionID = data.data.transaction_id;
          }
          if (data.data.uuid) {
            this.orderinfo.OrderID = data.data.uuid;
          }
          if (data.data.date) {
            this.orderinfo.Transactiondate = data.data.date;
          }

          if (data.data.real_amount) {
            this.orderinfo.real_amount = data.data.real_amount;
          } else {
            this.orderinfo.real_amount = this.gameinfo.money;
          }

          if (data.code == 15012) {
            this.maskstyle = 'deliveryfail'
          } else {
            this.maskstyle = 'payfail'
          }
        } else {
          this.orderinfo.real_amount = this.gameinfo.money;
          this.maskstyle = 'payfail'
        }
        this.$rum.report('pay_vip_fail', data, 1)
      },
      faipaypallpay(sty) {
        this.shwoPayComponent = false;
        this.orderinfo.real_amount = this.gameinfo.money;
        this.maskstyle = sty;
      },
      //子组件取消支付
      cancelpay() {
        this.shwoPayComponent = false
        // this.orderconfirm = true;
      },
      selpackage(item) {
        if (this.packageid === item.id) {
          return this.clearid()
        }

        //判断当前商品是否在当前支付方式中
        if (this.gateway_package_ids[this.gatewayMap[this.paysty]]) {
          this.idarr = this.gateway_package_ids[this.gatewayMap[this.paysty]];
          if (this.idarr.includes(item.id)) {
            this.packageid = item.id;
            this.pakcageis = true
            this.gameinfo.money = item.package.final_amount;
            this.gameinfo.packagename = item.package.package_en_name;
          } else {
            this.clearid();
          }
        }

        //console.log(item.id)
      },
      clearid() {
        this.packageid = '';
        this.gameinfo.money = 0;
        this.gameinfo.packagename = '';
      },
      openother(list, now, sty, id, index) {
        if (list.length && list.length > 1) {
          this.otherlist = list;
          this.nowselect = now;
          this.otherselectsty = {
            style: sty,
            id: id,
            index: index
          };
          this.otherselectis = true;
          document.documentElement.style.overflowY = 'hidden';

        }
        return false;
      },
      otherconfirm(item) {
        if (this.otherselectsty.style == 'other') {
          this.difpackageinfo['vip' + this.otherselectsty.id].other_content[this.otherselectsty.index] = item;
        } else {
          this.difpackageinfo['vip' + this.otherselectsty.id].main_content = item;
        }
        document.documentElement.style.overflowY = 'auto';
        this.otherselectis = false;
      },
      //diy礼包初始化
      diypackageinit(list) {
        this.difpackageinfo = {};
        var difpackageinfo = {}
        list.forEach((el) => {
          if (el.package_type && el.package_type == 2) {
            //difpackageinfo
            console.log('------difpackageinfo')
            console.log(el)

            var obj = {
              main_content: el.package.diy_main_content[0],
              other_content: []
            }
            for (let k in el.package.diy_other_content) {
              if (el.package.diy_other_content[k].length && el.package.diy_other_content[k].length > 0) {
                obj.other_content.push(el.package.diy_other_content[k][0])
              }
            }
            difpackageinfo['vip' + el.id] = obj;
          }
        })
        this.$set(this, 'difpackageinfo', difpackageinfo);
        console.log(this.difpackageinfo)


      },
      //礼包更新接口
      packagereset(fn) {
        packagesinfo({
          fpid: this.fpid,
          game_id: this.gameid,
          list_id: this.list_id,
          currency: this.conutry.money
        }).then(res => {
          console.log('packagereset')
          console.log(res)
          if (res.data.code == 1) {
            if (res.data.data) {
              var obj = {}
              res.data.data.package_info.forEach(item => {
                obj['a' + item.id] = item.left_count;
              });
              this.$set(this, 'gateway_package_ids', res.data.data.gateway_package_ids);
              //console.log(this.gateway_package_ids);
              this.list.forEach((el, index) => {
                if (el.id == this.packageid && (obj['a' + el.id] + '') == '0') {
                  this.clearid()
                }

                this.$set(this.list[index].package, 'limit_pay_count', obj['a' + el.id]);
              })
              //this.diypackageinit(this.list);
              this.list = this.resetlist(this.list)
            }
            if (fn) {
              fn();
            }
          } else {
            //console.log('礼包已经购买成功')
          }
        })
      },
      updateleftcount(sucess){
        this.setShowLoading(true);
        var obj = {
          'game_id': this.gameid,
          'currency': this.conutry.money,
          'fpid': this.gameinfo.id,
        }
        if (this.list_id != '' && this.list_id + '' != 'undefined') {
          obj.list_id = this.list_id;
        }
        //this.packagedict = {};
        packagesinfo(obj).then(res => {
          console.log('updateleftcount')
          if (res.data.code == 1) {
            this.$set(this, 'gateway_package_ids', res.data.data.gateway_package_ids);

            //更新 left_count
            if (res.data.data.package_info) {
              var obj = {}
              res.data.data.package_info.forEach(item => {
                obj['a' + item.id] = item.left_count;
              })
              this.list.forEach((el, index) => {
                if (el.id == this.packageid && (obj['a' + el.id] + '') == '0') {
                  this.clearid()
                }
                this.$set(this.list[index].package, 'limit_pay_count', obj['a' + el.id]);
              });
              this.list = this.resetlist(this.list);
            }

            if (this.packageid != '' && this.gameinfo.packagename == '' && this.packagedict['package' + this
                .packageid]) {
              console.log('------initno_package------')
              this.selpackage(this.packagedict['package' + this.packageid]);
            }

            if (sucess && typeof sucess === "function") {
              sucess();
            }

          }
          this.setShowLoading(false);
        })
      },
      async checkid(sty = '',sucess = null, session,nomsg) {
        if (this.gameinfo.id !== '' || session) {

          if (sty === 'login') {
            if (!this.privacyChecked) {
              return this.showCheckRequied = true
            } else {
              this.showCheckRequied = false
            }
          }

          if(this.checkis == true){
            return false;
          }else{
            this.checkis = true;
          }

          this.$set(this.gameinfo, 'icon', '');
          this.$set(this.gameinfo, 'name', '');
          this.$set(this.gameinfo, 'role_id', '');
          this.$set(this.gameinfo, 'extra_info', {});
          this.$set(this.gameinfo, 'player_whitelist_status', false);
          this.player_whitelist_status = false;

          try {
            let res = null
            if (session) {
              res = await getUserInfoBySession({
                session,
                game_id: this.gameid,
              })
            } else {
              res = await checkfpid({
                fpid: this.gameinfo.id,
                game_id: this.gameid,
              })
            }

            console.log('登录结果----')
            console.log(res)
            if (res.data.code == 1) {

              var dat = res.data.data.user_data[0];
              // 清除session
              localStorage.removeItem(this.gameid + 'vip_mall_code');
              localStorage.removeItem(this.gameid + 'vip_mall_code_url');




              //登录成功后去掉监听
              document.removeEventListener("visibilitychange", this.visibilitychangefn);

              //缓存当前id
              if (this.accept) {
                localStorage.setItem("game_user_id_"+this.gameid, dat.user_id)
              }
              this.$set(this.gameinfo, 'id', dat.user_id);
              this.$set(this.gameinfo, 'icon', dat.icon);
              this.$set(this.gameinfo, 'name', dat.nickname);
              this.$set(this.gameinfo, 'role_id', dat.role_id);
              this.$set(this.gameinfo, 'extra_info', dat.extra_info);
              this.$set(this.gameinfo, 'rank', dat.rank);
              // this.$set(this.gameinfo, 'real_role_id', dat.real_role_id);
              this.$set(this, 'fpid', dat.fpid);
              this.player_whitelist_status = dat.player_whitelist_status;

              this.$ta.setSuperProperties({
                // fake_id: dat.role_id,
                fpid: dat.fpid,
                env: this.env == 'production' ? 'production' : 'sandbox',
                uid: dat.role_id,
              })

              this.$ta.login(dat.role_id)

              //获取账单信息
              this.$set(this, 'mail_data', {
                ...res.data.data.mail_data,
                is_remember: false,
                is_send_information: false,
              });
              this.checktext = ''
              this.editis = true;

              // 关闭登陆弹窗
              this.closeAppLoginModal();
              if (dat.currency) {
                this.moneyunit = dat.currency_label + ' ';
                console.log('不一致');
                conutryarr.forEach(item => {
                  if (item.money === dat.currency) {
                    this.$store.commit('SET_COUNTRY', item);
                  }
                })
                this.$ta.setSuperProperties({
                  country: this.conutry.content,
                })
                this.list = []
                this.clearid();
              }
              this.getPackageInfo(() => {
                this.packagereset(() => {

                })
              })



              //判断币种是否和当前一致


              this.$rum.setShareProperties({
                userId: dat.role_id,
                gameid: this.gameid,
                fake_id: dat.role_id,
                fpid: dat.fpid,
                // real_role_id: dat.real_role_id
              })

              if(sty === 'login'){
                this.updateleftcount(sucess);
                this.$ta.track('tpp_vip_mall_combine', {
                  type: 1,
                  // server_id: dat.extra_info.value,
                })
              }

              //获取id成功后去更新leftcount
              if(sty === 'leftcount'){
                this.updateleftcount(sucess);
              }

              if (sty === 'cacheLogin') {
                this.$ta.track('tpp_vip_mall_view')
              }

            } else {
              //失败就返回
              if (typeof sucess === "function") {
                sucess();
              }

              //判断如果是点击按钮跳转的返回后 失败了则提示
              if(this.sessionclickis == true){
                this.opennotice(this.$t('game.logintip'), 'notice','','','',this.$t('game.loginfail'));
                this.sessionclickis = false;
              }

              //说明第一次进来重试session 不用提醒
              if(nomsg && nomsg=='nomsg'){

              }else{
                if (session) {
                   //不提示了
                }else{
                  this.checktext = this.$t('game.id404');
                }
              }
              this.setShowLoading(false)
            }

            this.checkis = false;
          } catch (error) {
            console.log(error)
          }
        } else {
          if (typeof sucess === "function") {
            sucess();
            this.checktext = this.$t('game.userIdNotice');
          }
        }

      },
      handleCheckedCitiesChange(value) {
        var arr = ['bonusoff', 'bonus', 'total', 'off'];
        var val = '';
        arr.forEach((item, index) => {
          if (value.indexOf(item) > -1) {
            val = item;
          }
        })
        this.disabledval = val;
      },
      //更新礼包顺序
      resetlist(list) {
        var newlist = [];
        var oldlist = [];
        list.forEach(item => {
          if (item.package.limit_pay_count < 0) {
            item.package.limit_pay_count = 0
          };

          if (item.package.limit_pay_count + '' != 'null' && item.package.limit_pay_count + '' == '0') {
            oldlist.push(item);
          } else {
            newlist.push(item);
          }
        })
        return newlist.concat(oldlist)
      },
      getPackageInfo(fn) {
        this.setShowLoading(true)
        var obj = {
          'game_id': this.gameid,
          'currency': this.conutry.money
        }
        if (this.list_id != '' && this.list_id + '' != 'undefined') {
          obj.list_id = this.list_id;
        }
        this.packagedict = {};
        gamePackagesInfo(obj).then(res => {
          if (res.data.code == 1) {
            let config = JSON.parse(res.data.data.config);
            console.log('gamePackagesInfo', config)
            this.checkList = config.checkList;

            //初始化diy
            this.diypackageinit(config.list);
            this.list = this.resetlist(config.list);
            this.list_id = res.data.data.id;
            this.list.forEach((item, index) => {
              this.packagedict['package' + item.id] = item;
            });
            this.gateway_package_ids = res.data.data.gateway_package_ids;
            if (this.list.length > 0) {
              this.moneyunit = this.list[0].package.currency_label + ' ';
            } else {
             this.nopackis = true;
            }

            if (res.data.data.paypal_client_id) {
              this.paypal_client_id = res.data.data.paypal_client_id;
            }

            this.advanceCardSupport = res.data.data.is_advance_card_support_currency;

            this.adyenDecimalPrecision = res.data.data.decimal_precision

            // 43：wechat, 14: alipay, 0: paypal, 75: adyen
            const payWayMap = {
              43: '微信',
              14: '支付宝',
              0: 'paypal',
              75: 'adyen',
            }
            const arr = []
            res.data.data.support_gateways.forEach(res => arr.push(payWayMap[res]));
            this.payway = arr;
            this.paysty = arr[0];
            this.handleCheckedCitiesChange(this.checkList)
            if (this.packageid != '' && this.packagedict['package' + this.packageid]) {
              this.selpackage(this.packagedict['package' + this.packageid]);
            }
            if (fn) {
              fn();
            }
          } else {
            this.nopackis = true;
          }
          this.setShowLoading(false)
        })
      },
      getQueryString(name) {
        return this.$route.query[name] || null;
      },
      priceinit(price) {

        if (price != null && price.indexOf('.') > -1) {
          price = (price * 1).toFixed(2)
        }
        if (price > 10000) {
          price = Math.ceil(price / 100) * 100;
        } else if (price > 1000) {
          price = Math.ceil(price);
        }

        return price;
      }

    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/game.vue